export const media = {
  small: 543,
  mobile: 767,
  tablet: 991,
  desktop: 1199,
  large: 1200,
};
